// extracted by mini-css-extract-plugin
export default {"Container":"WF7tA0IBvorn708n1mVA","Form":"SPS3eBeSNLdF7BQ_1vaZ"};